export default __webpack_public_path__ + "static/media/soccer.5f8d8ef1.svg";